import P from '../../pages';
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { defaultMessages } from '../../../../libs/i18n/default'
import ReactOnRails from 'react-on-rails'

class Footer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      page: this.props.page,
      content: this.props.content,
      pages: this.props.pages
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const pages = this.props.pages;
    const currentPage = this.props.page;
    const displayFooter = pages.indexOf(currentPage) > -1

    return (
      <div className='footer text-center'>
      {displayFooter && (<ul>
        {pages.map((page,i) => {
          return (
            <li key={page+i} className={'footer-'+page}>
              <a className={(currentPage == page) ? 'current' : ''} onClick={(e) => {e.preventDefault();}}></a>
            </li>
          )
        })}
        </ul>)}
      </div>
    )
  }
}

Footer.propTypes = {
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
}

export default injectIntl(Footer)

